
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';

@Injectable()
export class RoleScreenService {
  private baseApiUrl: string;

  constructor(configurationService: ConfigurationService, private httpClient: HttpClient) {
    this.baseApiUrl = configurationService.BaseApiUrl;
  }

  getAllScreens(): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + 'rolescreen').pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getRoleScreen(id: number,isMaintenance: boolean = false): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `rolescreen/${id}?isMaintenance=${isMaintenance}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
  createRoleScreen(rolescreen: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'rolescreen', rolescreen).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
  updateRoleScreen(rolescreen: any): Observable<any> {
    return this.httpClient.put(this.baseApiUrl + 'rolescreen', rolescreen).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
  delete(id: number): Observable<any> {
    return this.httpClient.delete(this.baseApiUrl + `rolescreen/${id}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }


  authorise(id: number): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'rolescreen/authorise', id).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getFilteredScreens(filter: string, pageIndex: number, pageSize: number,
    sortColumn: string, sortAscending: boolean, isMaintenance: boolean = false): Observable<any> {

    const params = {
      filter, pageIndex, pageSize, sortColumn, sortAscending, isMaintenance
    };

    return this.httpClient.post(this.baseApiUrl + 'rolescreen/filter', params).pipe(
      map((res: any) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

}
